import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Card } from 'src/app/models/card.model';
import { Deposit } from 'src/app/models/deposit.model';
import { Loan } from 'src/app/models/loan.model';
import { Saving } from 'src/app/models/saving.model';
import { AppState } from 'src/app/store';
import {
  DepositsViewModel,
  LoansViewModel,
  SavingsViewModel,
  selectDepositsViewModel,
  selectLoansViewModel,
  selectSavingsViewModel
} from 'src/app/store/selectors/accounts/accounts.selectors';
import {
  CardsViewModel,
  selectAllCardsViewModel
} from 'src/app/store/selectors/cards/cards.selectors';
import { Arrows } from '../../../enums/arrows.enum';
import * as fromTemplatesSelectors from '../../../store/selectors/templates/templates.selectors';
import { Account } from './../../../models/account.model';

@Component({
  selector: 'lns-title-arrows',
  templateUrl: './title-arrows.component.html',
  styleUrls: ['./title-arrows.component.scss']
})
export class TitleArrowsComponent implements OnInit {
  private unsubscribe: Subject<void> = new Subject<void>();
  @Output() arrowClick: EventEmitter<Arrows> = new EventEmitter<Arrows>();
  @Input() viewType?: string;
  arrows = Arrows;

  accounts$: Observable<fromTemplatesSelectors.TemplatesViewModel>;
  accounts!: Account[];
  currentAccount!: Account | null;

  cards$: Observable<CardsViewModel>;
  cards!: Card[];
  currentCard: any;

  savings$!: Observable<SavingsViewModel>;
  savings!: Saving[];
  deposits$!: Observable<DepositsViewModel>;
  deposits!: Deposit[];
  currentSaving!: Saving | null;
  currentDeposit!: Deposit | null;

  loans$!: Observable<LoansViewModel>;
  loans!: Loan[];
  currentLoan!: Loan | null;
  accountsAndSavings: any[] = [];

  constructor(private store: Store<AppState>) {
    this.accounts$ = this.store.select(
      fromTemplatesSelectors.selectTemplatesViewModel
    );
    this.cards$ = this.store.select(selectAllCardsViewModel);
    this.savings$ = this.store.select(selectSavingsViewModel);
    this.deposits$ = this.store.select(selectDepositsViewModel);
    this.loans$ = this.store.select(selectLoansViewModel);
  }

  ngOnInit(): void {
    this.getAccounts();
    this.getCards();
    this.getLoans();
    this.getSavings();
    this.getDeposits();
    this.accounts?.forEach((element: any) => {
      this.accountsAndSavings.push(element);
    });
    this.savings?.forEach((element: any) => {
      this.accountsAndSavings.push(element);
    });
  }

  getAccounts(): void {
    this.accounts$.pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.accounts = val.accounts ? val.accounts : [];
      this.currentAccount = val.selectedAccount;
    });
  }
  getLoans(): void {
    this.loans$.pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.loans = val.loans ? val.loans : [];
      this.currentLoan = val.selectedLoan;
    });
  }
  getSavings(): void {
    this.savings$.pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.savings = val.savings ? val.savings : [];
      this.currentSaving = val.selectedSaving;
    });
  }
  getDeposits(): void {
    this.deposits$.pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.deposits = val.deposits ? val.deposits : [];
      this.currentDeposit = val.selectedDeposit;
    });
  }
  getCards(): void {
    this.cards$.pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.cards = val.cards || [];
      this.currentCard = val.selectedCard;
    });
  }

  arrowHandler(type: Arrows): void {
    if (document.location.href.includes('sidebar:confirm-payment')) {
      this.arrowClick.closed;
      return;
    }
    if (this.viewType === 'cards') {
      if (
        type == Arrows.Next &&
        this.currentCard?.cardToken ===
          this.cards[this.cards.length - 1]?.cardToken
      ) {
        this.arrowClick.closed;
      } else if (
        type == Arrows.Previous &&
        this.currentCard?.cardToken === this.cards[0]?.cardToken
      ) {
        this.arrowClick.closed;
      } else {
        this.arrowClick.emit(type);
      }
    } else if (this.viewType === 'savings') {
      if (
        type == Arrows.Next &&
        this.currentSaving?.accountId ===
          this.savings[this.savings.length - 1]?.accountId
      ) {
        this.arrowClick.closed;
      } else if (
        type == Arrows.Previous &&
        this.currentSaving?.accountId === this.savings[0]?.accountId
      ) {
        this.arrowClick.closed;
      } else {
        this.arrowClick.emit(type);
      }
    } else if (this.viewType === 'deposits') {
      if (
        type == Arrows.Next &&
        this.currentDeposit?.accountId ===
          this.deposits[this.deposits.length - 1]?.accountId
      ) {
        this.arrowClick.closed;
      } else if (
        type == Arrows.Previous &&
        this.currentDeposit?.accountId === this.deposits[0]?.accountId
      ) {
        this.arrowClick.closed;
      } else {
        this.arrowClick.emit(type);
      }
    } else if (this.viewType === 'loans') {
      if (
        type == Arrows.Next &&
        this.currentAccount?.accountId ===
          this.loans[this.loans.length - 1]?.accountId
      ) {
        this.arrowClick.closed;
      } else if (
        type == Arrows.Previous &&
        this.currentLoan?.accountId === this.loans[0]?.accountId
      ) {
        this.arrowClick.closed;
      } else {
        this.arrowClick.emit(type);
      }
    } else if (this.viewType === 'retailPayments') {
      if (
        type == Arrows.Previous &&
        this.currentAccount?.accountId === this.accountsAndSavings[0]?.accountId
      ) {
        this.arrowClick.closed;
      } else {
        this.arrowClick.emit(type);
      }
    } else {
      if (
        type == Arrows.Next &&
        this.currentAccount?.accountId ===
          this.accounts[this.accounts.length - 1]?.accountId
      ) {
        this.arrowClick.closed;
      } else if (
        type == Arrows.Previous &&
        this.currentAccount?.accountId === this.accounts[0]?.accountId
      ) {
        this.arrowClick.closed;
      } else {
        this.arrowClick.emit(type);
      }
    }
  }

  checkIfArrowDisabled(type: Arrows) {
    if (document.location.href.includes('sidebar:confirm-payment')) {
      return false;
    }
    if (this.viewType === 'cards') {
      if (
        type == Arrows.Next &&
        this.currentCard?.cardToken ===
          this.cards[this.cards.length - 1]?.cardToken
      ) {
        return false;
      } else if (
        type == Arrows.Previous &&
        this.currentCard?.cardToken === this.cards[0]?.cardToken
      ) {
        return false;
      } else {
        return true;
      }
    } else if (this.viewType === 'savings') {
      if (
        type == Arrows.Next &&
        this.currentSaving?.accountId ===
          this.savings[this.savings.length - 1]?.accountId
      ) {
        return false;
      } else if (
        type == Arrows.Previous &&
        this.currentSaving?.accountId === this.savings[0]?.accountId
      ) {
        return false;
      } else {
        return true;
      }
    } else if (this.viewType === 'deposits') {
      if (
        type == Arrows.Next &&
        this.currentDeposit?.accountId ===
          this.deposits[this.deposits.length - 1]?.accountId
      ) {
        return false;
      } else if (
        type == Arrows.Previous &&
        this.currentDeposit?.accountId === this.deposits[0]?.accountId
      ) {
        return false;
      } else {
        return true;
      }
    } else if (this.viewType === 'loans') {
      if (
        type == Arrows.Next &&
        this.currentLoan?.accountId ===
          this.loans[this.loans.length - 1]?.accountId
      ) {
        return false;
      } else if (
        type == Arrows.Previous &&
        this.currentLoan?.accountId === this.loans[0]?.accountId
      ) {
        return false;
      } else {
        return true;
      }
    } else if (this.viewType === 'retailPayments') {
      if (
        type == Arrows.Next &&
        this.currentAccount?.accountId ===
          this.accountsAndSavings[this.accountsAndSavings.length - 1]?.accountId
      ) {
        return false;
      } else if (
        type == Arrows.Previous &&
        this.currentAccount?.accountId === this.accountsAndSavings[0]?.accountId
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        type == Arrows.Next &&
        this.currentAccount?.accountId ===
          this.accounts[this.accounts.length - 1]?.accountId
      ) {
        return false;
      } else if (
        type == Arrows.Previous &&
        this.currentAccount?.accountId === this.accounts[0]?.accountId
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
}
